import {
  ExportApi, ExportBody, ExportHealthBody // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { toEndOfDayIsoString, toStartOfDayIsoString } from '@util/dates-and-times'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedExportApi extends ExportApi {
  exportTrips (vehicleId: number, exportData: ExportBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)

    exportData.vehicleId = vehicleId
    exportData.from = toStartOfDayIsoString(exportData.from)
    exportData.until = toEndOfDayIsoString(exportData.until)

    optionsParam.basePath = basePath
    return super.exportTripsSkipVehicleId(exportData, undefined, optionsParam)
  }

  exportHealth (exportHealthBody: ExportHealthBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.exportHealth(exportHealthBody, undefined, options)
  }
}
